// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__gQBHF","center":"Footer_center__ddk45"};